"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _molecules = require("../../molecules");

var _classnames = _interopRequireDefault(require("classnames"));

var _stylesModule = _interopRequireDefault(require("./styles.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Table(props) {
  var _props$isResponsive = props.isResponsive,
      isResponsive = _props$isResponsive === void 0 ? true : _props$isResponsive,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'auxiliar-orange' : _props$variant,
      _props$nowrap = props.nowrap,
      nowrap = _props$nowrap === void 0 ? false : _props$nowrap,
      className = props.className;
  var theadClassName = (0, _react.useMemo)(function () {
    var isDark = variant === 'dark';
    return (0, _classnames.default)(variant && "bg-".concat(isDark ? 'secondary-blue' : variant));
  }, [variant]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(isResponsive && 'table-responsive', 'overflow-x-auto bg-white')
  }, /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames.default)(_stylesModule.default.table, 'w-full', nowrap && 'whitespace-nowrap', className)
  }, /*#__PURE__*/_react.default.createElement("thead", {
    className: (0, _classnames.default)(theadClassName)
  }, /*#__PURE__*/_react.default.createElement(_molecules.TableHeader, props)), /*#__PURE__*/_react.default.createElement("tbody", null, /*#__PURE__*/_react.default.createElement(_molecules.TableBody, props))));
}

Table.propTypes = {
  dataList: _propTypes.default.array,
  rowClassName: _propTypes.default.string,
  emptyMessage: _propTypes.default.string,
  rowClick: _propTypes.default.func,
  columns: _propTypes.default.array,
  isResponsive: _propTypes.default.bool,
  variant: _propTypes.default.string,
  nowrap: _propTypes.default.bool
};
Table.defaultProps = {
  dataList: [],
  columns: [],
  emptyMessage: 'No se encontró ningún elemento'
};
var _default = Table;
exports.default = _default;